export default {"src":"/_next/static/media/Cross.5f4b1e43.svg","height":15,"width":16};